// MODEL : instance of Column

define('app/editor/ColumnView',['require','app/config/aggregateOptions','./ColumnOptionsView','./ColumnMenuView','glu/itemView','glu/util','glu/$','glu/dialog','hbs!./ColumnView.hbs'],function(require) {
	'use strict';

	var AGGREGATE_OPTIONS = require('app/config/aggregateOptions'),
		ColumnOptionsView = require('./ColumnOptionsView'),
		ColumnMenuView = require('./ColumnMenuView'),
		ItemView = require('glu/itemView'),
		_ = require('glu/util'),
		$ = require('glu/$'),
		dialog = require('glu/dialog');

	return ItemView.extend({
		template: require('hbs!./ColumnView.hbs'),

		tagName: 'li',
		className: 'editColumnView',

		events: {
			'click .delete button': 'removeColumn',
			'click': 'openEditColumnNameDialog',
			'click .column-type-menu': 'toggleMenu',
			'mouseleave': 'closeMenu'
		},

		initialize: function() {

		},

		onRender: function() {
			this.generateMenu();
		},

		generateMenu: function() {
			var view = new ColumnMenuView({
				model: this.model,
				report: this.options.report
			});

			view.render();

			this.$el.find('.column-type-menu .menu').append(view.render().el);
		},

		toggleMenu: function(e) {
			e.preventDefault();
			e.stopPropagation();

			this.$el.find('.column-type-menu').toggleClass('active');
		},

		closeMenu: function() {
			this.$el.find('.column-type-menu').removeClass('active');
		},

		serializeData: function() {
			return this;
		},

		fieldName: function() {
			if (this.model.getAsName() && this.model.isManualAsName()) {
				return this.model.getAsName();
			}

			return this.model.fieldName();
		},

		fieldQualifiedName: function() {
			return this.model.fieldQualifiedName();
		},

		fieldId: function() {
			return this.model.fieldId();
		},

		measureOrDimension: function() {
			if (this.options.report.isGroupedAndAggregated()) {
				return this.model.hasAggregation() ? 'measure' : 'dimension';
			} else {
				return this.model.getField().isMeasure() ? 'measure' : 'dimension';
			}
		},

		aggregation: function() {
			var options = AGGREGATE_OPTIONS[this.model.getField().isMeasure() ? 'MEASURE' : 'DIMENSION'];
			var aggregationValue = this.model.getAggregation();
			var aggregation = _.find(options, function(opt) {
				return opt.value === aggregationValue;
			});
			var aggregationLabel = aggregationValue;
			if (aggregation) {
				aggregationLabel = aggregation.label;
			}

			return aggregationLabel;
		},

		isPercentage: function() {
			return this.model.isPercentage();
		},

		removeColumn: function(e) {
			e.preventDefault();
			e.stopPropagation();

			this.model.remove();
			this.appBus.trigger('refresh');
		},

		templateHelpers: function() {
			var self = this;

			return {
				columnId: self.model.cid
			};
		},

		setAsAggregate: function() {
			var self = this;

			// Enable aggregation mode if it isn't already enabled
			if (!this.options.report.hasAggregateColumns() && !$('#group-and-aggregate-checkbox').prop('checked')) {
				self.options.report.setGroupedAndAggregated(true);
				$('#report-definition').children().first().toggleClass('is-grouping-hidden', false);
				$('#group-and-aggregate-checkbox').prop('checked', false);
			}

			// Move to aggregate column
			this.options.report.moveColumnToCategory(this.model.cid, 'aggregated');

			this.appBus.trigger('refresh');
		},

		setAsGroup: function() {
			var self = this;

			if (!this.options.report.hasAggregateColumns() && !$('#group-and-aggregate-checkbox').prop('checked')) {
				self.options.report.setGroupedAndAggregated(true);
				self.options.report.setAllColumnsToAggregate();

				$('#report-definition').children().first().toggleClass('is-grouping-hidden', false);
				$('#group-and-aggregate-checkbox').prop('checked', false);
			}

			// Move to group column
			this.options.report.moveColumnToCategory(this.model.cid, 'grouped');

			this.appBus.trigger('refresh');
		},

		hasAggregation: function() {
			return this.model.hasAggregation();
		},

		index: function() {
			return this.model.collection.indexOf(this.model);
		},

		openEditColumnNameDialog: function(e) {
			e.preventDefault();
			var view = new ColumnOptionsView({
				model: this.model,
				report: this.options.report
			});

			dialog.open(view);
		}

	});

});

